export type TopVisibleAnchor = {
  eventId: number
  offsetPx: number
}

/**
 * Finds the top-most visible chat event in the viewport.
 * Only scans virtua-mounted rows (not the full history DOM).
 */
export const findTopVisibleAnchor = (container: HTMLElement): TopVisibleAnchor | undefined => {
  const containerRect = container.getBoundingClientRect()
  const viewportTop = containerRect.top
  const viewportBottom = containerRect.bottom
  let topAnchor: TopVisibleAnchor | undefined

  const nodes = container.querySelectorAll('.chat-event-list-item[data-event-id]')
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i] as HTMLElement
    const eventIdAttr = node.getAttribute('data-event-id')
    if (!eventIdAttr) continue

    const eventId = Number.parseInt(eventIdAttr, 10)
    if (Number.isNaN(eventId)) continue

    const rect = node.getBoundingClientRect()
    // Skip fully above viewport; stop once past bottom (rows are top-to-bottom).
    if (rect.bottom <= viewportTop) continue
    if (rect.top >= viewportBottom) break

    const offsetPx = rect.top - viewportTop
    if (!topAnchor || offsetPx < topAnchor.offsetPx) {
      topAnchor = { eventId, offsetPx }
    }

    // First intersecting row is the top-most for a top-to-bottom list.
    if (topAnchor) break
  }

  return topAnchor
}
